import { Container as container, Row as row, Col as col } from "styles/grid"

export const Container = container
export const Row = row
export const Col = col
